import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { mainColors } from 'src/assets/colors';

interface PropsType {
    className?: string;
    onClick?: (event?: unknown) => void;
    children?: React.ReactNode;
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

/**
 * @deprecated
 * Please use CloseIcon from src/components/icons/CloseIcon
 */

export const CloseIcon = observer(
    ({ className, onClick }: PropsType): React.ReactElement => (
        <SvgWrapper
            width={26}
            height={26}
            className={className}
            onClick={onClick}
            viewBox='0 0 26 26'
            fill={mainColors.main.primary}
        >
            <path
                fill='none'
                d='M0 0H26V26H0z'
                transform='translate(-1382 -200) translate(224 160) translate(0 32) translate(1158 8)'
            />
            <path
                fill='#fill'
                fillRule='nonzero'
                d='M6.976 6.976c.635-.635 1.663-.635 2.298 0L13 10.701l3.726-3.725c.597-.597 1.544-.632 2.182-.105l.116.105c.635.635.635 1.663 0 2.298L15.299 13l3.725 3.726c.597.597.632 1.544.105 2.182l-.105.116c-.635.635-1.663.635-2.298 0L13 15.299l-3.726 3.725c-.597.597-1.544.632-2.182.105l-.116-.105c-.635-.635-.635-1.663 0-2.298L10.701 13 6.976 9.274c-.597-.597-.632-1.544-.105-2.182z'
                transform='translate(-1382 -200) translate(224 160) translate(0 32) translate(1158 8)'
            />
        </SvgWrapper>
    )
);
